// @flow
/** @jsx jsx */

import { css, jsx } from '@emotion/core';

import type { Node } from 'react';

type Props = {
  area?: string,
  children: Node,
  span?: number,
};

const gridCellCss = (props: Props) =>
  css(
    {
      gridColumn: props.span ? `span ${props.span}` : 'auto',
    },
    props.area && {
      gridArea: props.area,
    }
  );

const GridCell = (props: Props) => {
  return <div css={gridCellCss(props)}>{props.children}</div>;
};

export default GridCell;
